import Contract from "slotworks/utils/contract";
import Components from "slotworks/components/components";
import { parallel } from "slotworks/utils/race-utils";

export default function CelebrateScatterCommand(): Contract<void> {
    const scatters = Components.matrix.getGridSymbols().filter((s) => s.symbolId === "SCATTER");
    const funcs = [];
    for(let scatter of scatters) {
        funcs.push(() => scatter.win());
    }
    return parallel(funcs);
}